var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-nav-menu",class:_vm.rootThemeClasses},[_c('nav-links',{attrs:{"linkComponent":"HorizontalNavMenuHeaderLink"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }